<div class="sections-indexer" [class.sticky-sections-indexer]="sticky">
  <div
    *ngFor="let section of sections"
    class="indexer-item"
    [class.indexer-item-active]="section.active"
    (click)="scrollTo(section)"
    [innerText]="section.title"
  ></div>
</div>
